<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { register } from '$lib/stores/auth';

  const dispatch = createEventDispatcher<{
    registered: { username: string };
    close: void;
  }>();

  let username = '';
  let error = '';
  let loading = false;

  async function handleSubmit() {
    error = '';

    // Validate username
    if (username.length < 3) {
      error = 'ユーザー名は3文字以上必要です';
      return;
    }
    if (username.length > 20) {
      error = 'ユーザー名は20文字以内にしてください';
      return;
    }
    if (!/^[a-z0-9_-]+$/.test(username)) {
      error = '小文字英数字、アンダースコア、ハイフンのみ使用できます';
      return;
    }

    loading = true;

    try {
      await register(username);
      dispatch('registered', { username });
    } catch (err: any) {
      console.error('Registration failed:', err);
      if (err.code === 'CONFLICT') {
        error = 'このユーザー名は既に使用されています';
      } else if (err.message.includes('reserved')) {
        error = 'このユーザー名は予約されています';
      } else {
        error = err.message || '登録に失敗しました';
      }
    } finally {
      loading = false;
    }
  }

  function handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      dispatch('close');
    }
  }
</script>

<svelte:window on:keydown={handleKeydown} />

<div
  class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
  on:click|self={() => dispatch('close')}
>
  <div class="bg-white rounded-xl shadow-xl max-w-md w-full p-6">
    <h2 class="text-xl font-bold text-gray-900 mb-4">ユーザー名を設定</h2>

    <p class="text-gray-600 text-sm mb-4">
      あなたのページは <span class="font-mono text-blue-500">velf.me/{username || 'username'}</span> になります
    </p>

    <form on:submit|preventDefault={handleSubmit}>
      <div class="mb-4">
        <label for="username" class="block text-sm font-medium text-gray-700 mb-1">
          ユーザー名
        </label>
        <input
          id="username"
          type="text"
          bind:value={username}
          placeholder="username"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
          disabled={loading}
          autocomplete="off"
          pattern="[a-z0-9_-]+"
        />
        <p class="text-xs text-gray-500 mt-1">
          3-20文字、小文字英数字・アンダースコア・ハイフンのみ
        </p>
      </div>

      {#if error}
        <div class="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm">
          {error}
        </div>
      {/if}

      <div class="flex gap-3">
        <button
          type="button"
          on:click={() => dispatch('close')}
          class="btn btn-secondary flex-1"
          disabled={loading}
        >
          キャンセル
        </button>
        <button
          type="submit"
          class="btn btn-primary flex-1"
          disabled={loading || !username}
        >
          {loading ? '登録中...' : '登録'}
        </button>
      </div>
    </form>
  </div>
</div>
